/**
 * Online Processing & Packing Slip (FC), Packaging's list (legacy seedtrac Packaging › "Online
 * Processing & Packing Slip (FC)", user 2026-11-04): the P&P Slips (FC) Processing sent, Pending until
 * Packaging fills the processing and packing details and Final Submits them, then Completed.
 */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { SlipListPage } from "@/features/processing/components/slip-list-page";

const search = z.object({
  tab: z.enum(["pending", "submitted"]).default("pending"),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/packaging/pnp-fc-slip/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();

  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <SlipListPage
      form="pnp_fc"
      packaging
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({
          // Packaging's list shows its two tabs only.
          search: (prev) => ({
            ...prev,
            ...next,
            // A page or date change keeps the tab shown.
            tab:
              next.tab === undefined
                ? prev.tab
                : next.tab === "submitted"
                  ? "submitted"
                  : "pending",
          }),
        })
      }
    />
  );
}
